import type { SetTldCostsRequest } from "@kilat/contracts/tld-pricing";
import { useMutation } from "@tanstack/react-query";
import { setTldCosts } from "../api";
import { staffKeys } from "../queries";

export const useSetTldCosts = (tldId: string) =>
  useMutation({
    mutationFn: (costs: SetTldCostsRequest) => setTldCosts(tldId, costs),
    onSuccess: (_data, _costs, _result, { client }) => {
      void client.invalidateQueries({ queryKey: staffKeys.tldPricing() });
    },
  });
